import defaultHeroImage from "../assets/construction3.png";

export default function PageHero(props) {
  const {
    eyebrow,
    title,
    text,
    image = defaultHeroImage,
  } = props;

  return (
    <section
      className="tgm-page-hero"
      style={{ "--tgm-page-hero-image": `url("${image}")` }}
      data-aos="fade-up"
    >
      <div className="container">
        <div className="tgm-page-hero-copy">
          {eyebrow ? <p className="tgm-page-hero-eyebrow">{eyebrow}</p> : null}
          <h1 className="tgm-page-hero-title">{title}</h1>
          {text ? <p className="tgm-page-hero-text">{text}</p> : null}
        </div>
      </div>
    </section>
  );
}
